// import '@babel/polyfill'
// import 'isomorphic-fetch';
// import es6promise from 'es6-promise';
// import objectFitImages from 'object-fit-images';

// es6promise.polyfill();
// objectFitImages();

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// https://github.com/flpvsk/gatsby-plugin-gtag

export const onRouteUpdate = ({ location }) => { 
  if (process.env.NODE_ENV !== 'production') return;

  const gtagTrackingId = window.GTAG_TRACKING_ID;
  const gtagAnonymize  = window.GTAG_ANONYMIZE || false;

  const locationStr = location
  ? `${location.pathname}${location.search}${location.hash}`
  : '';

  if (gtagTrackingId && typeof window.gtag === 'function') {
    window.gtag('config', gtagTrackingId, {
      'page_path': locationStr,
      ...(gtagAnonymize ? { anonymize_ip: true } : {}),
    });
  }

  if (typeof window.fbq === 'function') {
    window.fbq('track', 'ViewContent', {
      page_path: locationStr
    });
  }

};